import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  FaArrowLeft,
  FaCalendarAlt,
  FaClock,
  FaShareAlt,
  FaUser,
} from "react-icons/fa";
import NavBar from "./nav";
import Footer from "./footer";
import { blogPosts } from "./blogData";
import "../css/newsDescription.css";

const NewsDescription = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { slug } = useParams();
  const post =
    location.state?.post || blogPosts.find((article) => article.slug === slug);

  if (!post) {
    return (
      <div className="news-description-page">
        <NavBar />
        <main className="news-detail-container">
          <button className="news-back-button" onClick={() => navigate(-1)} type="button">
            <FaArrowLeft />
            Back
          </button>
          <section className="news-empty-state">
            <h1>Article not found</h1>
            <p>Please return to the homepage and choose a news article.</p>
          </section>
        </main>
        <Footer />
      </div>
    );
  }

  const relatedPosts = blogPosts
    .filter((article) => article.slug !== post.slug)
    .slice(0, 3);

  return (
    <div className="news-description-page">
      <NavBar />
      <main className="news-detail-container">
        <button className="news-back-button" onClick={() => navigate(-1)} type="button">
          <FaArrowLeft />
          Back
        </button>

        <article className="news-article">
          <header className="news-hero">
            <div className="news-hero-copy">
              <div className="news-tags">
                {post.tags.map((tag) => (
                  <span key={tag}>{tag}</span>
                ))}
              </div>
              <h1>{post.title}</h1>
              <p>{post.description}</p>
              <div className="news-meta">
                <span>
                  <FaUser />
                  {post.author}
                </span>
                <span>
                  <FaCalendarAlt />
                  {post.date}
                </span>
                <span>
                  <FaClock />
                  {post.readTime}
                </span>
              </div>
            </div>

            <div className="news-hero-image">
              <img src={post.image} alt={post.title} />
            </div>
          </header>

          <div className="news-content-grid">
            <div className="news-body">
              {post.content.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>

            <aside className="news-side-panel">
              <div className="news-share-card">
                <FaShareAlt />
                <h2>Share The Story</h2>
                <p>Keep this Kimberley travel note handy for your next city route.</p>
              </div>

              <div className="news-related-card">
                <h2>More Reads</h2>
                {relatedPosts.map((article) => (
                  <button
                    key={article.slug}
                    type="button"
                    onClick={() =>
                      navigate(`/news/${article.slug}`, {
                        state: { post: article },
                      })
                    }
                  >
                    <span>{article.tags[0]}</span>
                    {article.title}
                  </button>
                ))}
              </div>
            </aside>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
};

export default NewsDescription;
